import React from 'react';
import { Container, Typography, Box, Alert } from '@mui/material';
import AdminNavbar from './AdminNavbar'; // Import the AdminNavbar component
import './AdminDashboardLayout.css'; // Import specific admin styles

const AdminDashboard = () => {
    return (
        <div className="admin-dashboard-layout">
            <AdminNavbar />
            <Container className="admin-dashboard-content">
                <Box sx={{ my: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Admin Dashboard
                    </Typography>
                    <Typography variant="body1">
                        Welcome to the admin dashboard! Here you can manage users, roles, and system settings.
                    </Typography>
                    <Alert severity="info" sx={{ mt: 2 }}>
                        Please use English while the admin dashboard is still being localized. Deutsch: Bitte derzeit auf Englisch arbeiten.
                    </Alert>
                </Box>
            </Container>
        </div>
    );
};

export default AdminDashboard;
